(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(14186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7999);
/* harmony import */ var components_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33825);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98784);




const Home = (param)=>{
    let { pageContent  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components__WEBPACK_IMPORTED_MODULE_1__/* .Layout */ .Ar, {
        translate: t,
        pageTitle: t("pages.home"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Hero__WEBPACK_IMPORTED_MODULE_2__/* .Hero */ .V, {
                hero: pageContent.Hero,
                alignHero: "center"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components__WEBPACK_IMPORTED_MODULE_1__/* .Block */ .gO, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "content"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .TeaserGrid */ .GH, {
                                gap: "sm",
                                columns: 7,
                                children: pageContent.HeroCard.map((attributes, i)=>{
                                    var _attributes_logo;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .HeroCard */ .FH, {
                                        text: attributes.text,
                                        backgroundColor: attributes.background_color,
                                        width: attributes.width,
                                        logo: (_attributes_logo = attributes.logo) === null || _attributes_logo === void 0 ? void 0 : _attributes_logo.data
                                    }, i);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-10 md:h-20"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .ContentBuilder */ .Fo, {
                        contentBlocks: pageContent.page_content_blocks
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .SectionSeparator */ .du, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .Block */ .gO, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .Contact */ .r8, {
                            contact: pageContent.Contact
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [12,28,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);